let _0x62073b = "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";Function(window["\x61\x74\x6F\x62"](_0x62073b))();

$('.share-button').click(function(){
    var urlToShare = $(this).attr('share-url');
    navigator.share({ url: urlToShare, title: document.title });
});

document.querySelector(".search-main-icon")?.addEventListener("click", () => {
  const input = document.querySelector("#bc-sf-search-box-1");
  if (input) input.value = "";
});

$(document).ready(function() {
    // Target the svg inside .nosto-hedaing-section
    $('.nosto-hedaing-section svg').on('click', function() {
        alert('vmmvfvkdfvfdvf');
      
        // Trigger a click event on the .product-side-guid
        $('.template-product__product-form')
            .find('.product-option-size')
            .find('.text-link.product-side-guid')
            .trigger('click');
    });
  
    // $(document).on('click', '.label-text', function() {
    //   $(this).parents('.col-choice-box-textarea-wrapper').toggleClass('is-active');
    //   $(this).parents('.col-choice-box').find('.checkbox-container').toggleClass('is-active');
    // });
});

$(document).ready(function() {

  // $(document).on('click', '.atc-cart-btn', function() {
  //   var added = JSON.parse($('#ProductJson-product-template').text());
  //   // Size selection (only set if size exists)
  //   var size = $('.option-selector.is-active').find('.option-selector__button').text();
  //   if (size) {
  //       $('#cart-product-size').text(size);
  //       $('.cart-product-size').show();
  //   } else {
  //       $('.cart-product-size').hide();
  //   }
  //   // Update cart drawer content
  //   $('#cart-product-image').attr('src', added.images[0]);
  //   $('#cart-product-name').text(added.title);
  //   $('#cart-product-price').text($('#currency_symbol').val() + (added.compare_at_price / 100));
  //   $('#cart-product-compare-price').text($('#currency_symbol').val() + (added.price / 100));
  
  //   // Show cart drawer
  //   $('.product-added-cart-drawer-overlay').addClass('active');
  //   $('.product-added-cart-drawer').addClass('active');
  // });


  // Close cart drawer on overlay or close icon click
  $(document).on('click', '.product-added-cart-drawer-overlay, .close-icon', function() {
    $('.product-added-cart-drawer-overlay').removeClass('active');
    $('.product-added-cart-drawer').removeClass('active');
    $('body').removeClass('overflow-hidden'); 
  });

  $(document).on('click', '.shopping-bag-icon', function() {
    console.log('here');
    updateCartDrawer();
    $('.cart-drawer-overlay').addClass('active');
    $('.cart-drawer').addClass('active');
    $('body').addClass('overflow-hidden'); // Add class to body
  });

  $(document).on('click', '.cart-drawer-overlay', function() {
    $('.cart-drawer-overlay').removeClass('active');
    $('.cart-drawer').removeClass('active');
    $('body').removeClass('overflow-hidden');
  });

  $(document).on('click', '.cart-drawer-close-icon', function() {
    $('.cart-drawer-overlay').removeClass('active');
    $('.cart-drawer').removeClass('active');
    $('body').removeClass('overflow-hidden');
 });

$(document).on('click', '.quntity-plus-button', function() {

  var id = $(this).data('item-id');
  var quantity = parseInt($(this).parent('.qty-selector').find('.qty-selector__input').val()) + 1;
    $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        dataType: 'json',
        data: {
          id: id,
          quantity: quantity
        },
        success: function(response) {
            updateCartDrawer();
            window.updateJellycatShippingAttribute();
        },
        error: function(xhr, status, error) {
            console.error('Error fetching cart data:', error);
        }
    });

});

$(document).on('click', '.quntity-minus-button', function() {

  if (parseInt($(this).siblings('.qty-selector__input').val()) == 1) {
    return false;
  }

  var id = $(this).data('item-id');
  var quantity = parseInt($(this).parent('.qty-selector').find('.qty-selector__input').val()) - 1;
    
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      dataType: 'json',
      data: {
        id: id,
        quantity: quantity
      },
      success: function(response) {
          updateCartDrawer();
          window.updateJellycatShippingAttribute();
      },
      error: function(xhr, status, error) {
          console.error('Error fetching cart data:', error);
      }
    });
  });

  $(document).on('click', '.cart-item-remove', function() {

    var id = $(this).data('item-id');
    $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        dataType: 'json',
        data: {
        id: id,
        quantity: 0
      },
       success: function(response) {
             updateCartDrawer();
             window.updateJellycatShippingAttribute();
      },
      error: function(xhr, status, error) {
          console.error('Error removing item:', error);
      }
    });
});

});


function updateCartDrawer() {
  $.ajax({
      type: 'GET',
      url: window.location.href,
      success: function(html) {
        document.getElementById('cart-drawer-parent').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('cart-drawer-parent').innerHTML;
        document.getElementById('site-header__bag').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('site-header__bag').innerHTML;
      }
  });
}








